import React from "react";

import HeroHeader from "../../components/HeroHeader";
import NewsSection from "../../components/NewsSection";
import AgendaSection from "../../components/AgendaSection";
import ProjetsSection from "../../components/ProjetsSection";
import CarteInteretsTeaser from "../../components/CarteInteretsTeaser";
import PublicationsSection from "../../components/PublicationsSection";
import AboutSection from "../../components/AboutSection";
import FormContact from "./FormContact";
import HomeAlertBanner from "../../components/HomeAlertBanner";
import HomeNewsletterSubscribe from "../../components/HomeNewsletterSubscribe";
import HomeWeatherPanel from "../../components/HomeWeatherPanel";
import HomeCommuneCaroussel from "../../components/HomeCommuneCarousel";

import useScrollToTop from "../../hooks/useScollToTop";
import ScrollIndicator from "./ScrollIndicator";

export default function HomePage() {
  useScrollToTop();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <ScrollIndicator />

      <HeroHeader />

      <HomeAlertBanner />
      <HomeWeatherPanel />

      <main className="pb-20">
        <AboutSection />
        <HomeCommuneCaroussel />
        <NewsSection />
        <AgendaSection />
        <ProjetsSection />
        <CarteInteretsTeaser />
        <PublicationsSection />
        <HomeNewsletterSubscribe />
        <section id="contact" data-contact-section className="scroll-mt-28">
          <FormContact />
        </section>
      </main>
    </div>
  );
}
